import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/map';
import { timeout } from "rxjs/operator/timeout";


@Injectable()
export class ReferrerService {
    http: Http;

    referrersDataChange = new Subject<void>();
    referrers = [];
    private referrersData = [];


    constructor(http: Http) {
        this.http = http;
    }


    // Referrers
    fetchReferrers(media) {
        this.http.get(`/api/referrers/${media}`)
            .map((response: Response) => {
                const data = response.json();
                this.referrers = [{
                    "referrers": data.referrers,
                    "active": data.active
                }];


                return this.referrers;
            })
            .subscribe(
            (data) => {
                this.referrersData = data;
                setTimeout(() => this.referrersDataChange.next(), 1000 * 5);
            }
            );
    }

    fetchReferrersData() {
        // console.log(this.referrersData);
        return this.referrersData;
    }

}


// WEBPACK FOOTER //
// /home/node/src/app/_services/referrer.service.ts